import { Injectable, NgZone, OnDestroy } from '@angular/core'
import { AuthService } from '@services/auth.service'
import { RealtimeHealthService } from '@services/realtime/realtime-health.service'
import { ElectronicProcessBook } from '@models/planning/electronic-process-book.model'
import { ProcessTopicSocket } from '@services/socket/process-topic-socket'
import { StompConnectionService } from '@services/socket/stomp-connection.service'

/**
 * Livro eletrônico em tempo real (spec 001): cada mudança de uma geração (fila, fases, progresso, resultado, falha,
 * encerramento por tempo) chega em `/topic/tenant.{tenantId}.electronic-process-books.process.{processId}`, com o mesmo
 * corpo do `GET electronic-processes/{id}/books/{bookId}`.
 */
@Injectable({ providedIn: 'root' })
export class ElectronicProcessBookSocketService extends ProcessTopicSocket<ElectronicProcessBook> implements OnDestroy {
	protected readonly channel = 'book'
	protected readonly topic = 'electronic-process-books'

	constructor(health: RealtimeHealthService, authService: AuthService, stomp: StompConnectionService, zone: NgZone) {
		super(health, authService, stomp, zone)
	}

	protected parse(body: unknown): ElectronicProcessBook {
		return new ElectronicProcessBook(body as Partial<ElectronicProcessBook>)
	}

	ngOnDestroy(): void {
		void this.disconnect()
	}
}
